<template>
    <div class="treeview">

        <div class="card panel" style="over">

            <div class="actions">
                <h3>Project Overview</h3>
            </div>

            <div class="table-responsive">
                <div id="treeview" class="container">
                    <ul>
                        <li data-jstree='{"icon":"/images/overview/project.png"}'>
                            <span v-text="project.number + ' - ' + project.name"></span>
                            <ul v-for="(building, bindex) in treeview.buildings" :key="bindex">

                                <li data-jstree='{"icon":"/images/overview/building.png"}'>
                                    <span v-text="'Building: ' + building.name"></span>
                                    <ul v-for="(floor, findex) in building.floors" :key="findex">
                                        <li>
                                            <span v-text="'Floor: ' + floor.name"></span>
                                            <ul v-for="(space, sindex) in floor.spaces" :key="sindex">
                                                <li>
                                                    <span v-text="space.name"></span>
                                                    <ul v-for="(form, findex)  in space.forms" :key="findex">
                                                        <li class="form-item">
                                                            <a :href="form.path">
                                                            <span>
                                                                <i :class="form.icon"></i>
                                                                <span v-text="form.name"></span>
                                                            </span>
                                                            </a>
                                                            <ul v-for="(untested_area, key)  in form.untested_areas" :key="key">
                                                                <li class="untested-area-item">
                                                                    <a>
                                                                    <span>
                                                                        <i :class="untested_area.icon"></i>
                                                                        Untested Area: <span class="font-italic" v-text="untested_area.name"></span>
                                                                    </span>
                                                                    </a>
                                                                </li>
                                                            </ul>
                                                        </li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </li>

                                    </ul>
                                </li>
                                <li v-for="(form, findex) in treeview.forms" class="form-item">
                                    <a :href="form.path">
                                    <span>
                                        <i :class="form.icon"></i>
                                        <span v-text="form.name"></span>
                                    </span>
                                    </a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

    </div>
</template>
<script>

    require('jstree');

    export default {

        props:{
            project:{
                type: Object,
                required: true,
            }
        },

        data() {
            return {
                treeview: []
            }
        },

        created() {
            App.request().get(`/projects/${this.project.slug}/treeview`).then(response => {
                this.treeview = response.data.treeview.project;
                this.$nextTick(() => {
                    $("#treeview").on('changed.jstree', (e, data) => {
                        this.redirectTo(data.node.a_attr.href);
                    }).jstree();
                    $("#treeview").jstree('open_all');
                })
            })
        },
    }
</script>
